import { render } from "./StoreTransferArrivalView.vue?vue&type=template&id=620421e6&scoped=true"
import script from "./StoreTransferArrivalView.vue?vue&type=script&lang=js"
export * from "./StoreTransferArrivalView.vue?vue&type=script&lang=js"

import "./StoreTransferArrivalView.vue?vue&type=style&index=0&id=620421e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-620421e6"]])

export default __exports__